import { Injectable } from '@angular/core';
import {DashboardApi} from '../api/dashboard.api';
import {Dashboard} from '../models/dashboard';
import {DashboardDesignSetting} from '../models/dashboard-design-setting';

@Injectable()
export class DashboardDesignSettingsVersionManagerService {

  private currentVersion: [number, number, number] = [0,0,1];


  constructor(private dashboardApi: DashboardApi) { }

  getCurrentVersionValue(): string {
    return this.currentVersion.toString().replaceAll(',','.');
  }

  needUpdate(version: string): boolean {
    if (version == null){
      return true;
    }
    const splitVersion = version.split('.');
    for (let i = 0; i < this.currentVersion.length; i++){
      if(Number(splitVersion[i]) !== this.currentVersion[i]){
        return true;
      }
      if(i === this.currentVersion.length - 1 && Number(splitVersion[i]) === this.currentVersion[i]){
        return false;
      }
    }
    return true;
  }

  updateDesignSettings(dashboard: Dashboard): DashboardDesignSetting {
    if(dashboard.dashboardDesignSettings.version == null) {
      return  this.updateToVersion0o0o1(dashboard);
    }
    return dashboard.dashboardDesignSettings;
  }

  private updateToVersion0o0o1(dashboard: Dashboard) {
    dashboard.dashboardDesignSettings.version = this.getCurrentVersionValue();
    this.dashboardApi.updateDashboardVersioningProperties(dashboard.workspaceId, dashboard.dashboardId,
        dashboard.dashboardDesignSettings, dashboard.chartsGrid).subscribe();
    return dashboard.dashboardDesignSettings;
  }
}
